// extracted by mini-css-extract-plugin
export default {"statisticSectionContainer":"StatisSection_statisticSectionContainer__LdiI4","statisticContentWrapper":"StatisSection_statisticContentWrapper__L8ZfH"};